import { createSlice } from '@reduxjs/toolkit';
import { displayInitialState } from './display.defaults';

export const profileCollectorDisplaySlice = createSlice({
  name: 'display',
  initialState: displayInitialState,
  reducers: {
    OPEN_FILTERS_ProfileCollector: (state) => {
      state.isFiltersDialogOpen = true;
    },
    CLOSE_FILTERS_ProfileCollector: (state) => {
      state.isFiltersDialogOpen = false;
    },
  },
});
